import { captchaRequiredMessageMap } from './errorDictionary';
import useValidators from './useValidators';
const isCaptchaCompleted = (value) => value != null;
function useValidCaptcha() {
    return useValidators([captchaRequiredMessageMap], [isCaptchaCompleted]);
}
export default useValidCaptcha;
